import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader, Stack, Text } from "@mantine/core";
import { useLocation } from "react-router-dom";

import CoachReport from "@legacy/Reports/CoachReport";
import SelectReport from "@legacy/Reports/SelectReport";

import "@legacy/Reports/index.scss";
import "./ClearscreenReportPage.scss";

export default function ClearscreenReportPage() {
  const { pathname, search } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  const calcId = parts[1];
  const opccId = parts[2];
  const params = new URLSearchParams(search);
  const kind = params.get("kind") || "coach";
  const printTicket = params.get("print_ticket");
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState(null);
  const [ready, setReady] = useState(false);
  const pdfUrl =
    calcId && opccId
      ? `/clearscreen-calculations/${calcId}/occupational-profile-calculation-containers/${opccId}/pdf/`
      : "";

  useEffect(() => {
    if (!calcId || !opccId) return;
    const headers = {};
    if (printTicket) {
      headers["print-ticket"] = printTicket;
    }
    axios
      .get(
        `/clearscreen-calculations/${calcId}/occupational-profile-calculation-containers/${opccId}/report/`,
        {
          headers,
          params: printTicket ? { print_ticket: printTicket } : undefined,
        }
      )
      .then(({ data }) => {
        setPayload(data.response?.[0] || null);
        setError(null);
      })
      .catch((err) => {
        setPayload(null);
        setError(err);
      });
  }, [calcId, opccId, printTicket]);

  useEffect(() => {
    if (!payload) return undefined;
    let cancelled = false;
    const markReady = () => {
      window.setTimeout(() => {
        if (!cancelled) setReady(true);
      }, 500);
    };
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(markReady).catch(markReady);
    } else {
      markReady();
    }
    return () => {
      cancelled = true;
    };
  }, [payload]);

  if (error) {
    return (
      <Stack p="xl" data-report-ready="error">
        <Text>Could not load this report.</Text>
      </Stack>
    );
  }

  if (!payload) {
    return (
      <Stack p="xl">
        <Loader size="sm" />
        <Text size="sm">Loading report…</Text>
      </Stack>
    );
  }

  const reportProps = {
    data: payload,
    pathname,
    pdfUrl,
    kind,
    hideDownload: Boolean(printTicket),
  };

  return (
    <div
      className="clearscreen-report-window"
      data-report-ready={ready ? "true" : "false"}
    >
      {kind === "select" ? (
        <SelectReport {...reportProps} />
      ) : (
        <CoachReport {...reportProps} />
      )}
    </div>
  );
}
